import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { yjDailyPlayerDetails } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew, gmToolNewPage, tabulation } from "@/mixins/index";
import historyList from "./components/historyList";
export default {
  name: "playerDailySnapshot",
  mixins: [tabulation, gmToolNew, gmToolNewPage],
  components: {
    historyList: historyList
  },
  data: function data() {
    return {
      advanced: false,
      currentPage: 1,
      tableData: [],
      dayList: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30],
      paramsData: {
        special_product_id: [],
        role_id: "",
        open_server_day: "",
        page: 1,
        server_id: [],
        // server_ids: [],
        is_prod: ""
      },
      date: [],
      total: 0,
      serverList: [],
      exportdataDealoading: false,
      open_server_days: ''
    };
  },
  created: function created() {
    this.paramsData.is_prod = "";
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    selectAll: function selectAll() {
      var _this = this;

      this.paramsData.server_id = [];

      if (this.checked) {
        this.serverListYJ.map(function (item) {
          _this.paramsData.server_id.push(item.serverID + '+' + item.openTime);
        });
      } else {
        this.paramsData.server_id = [];
      }
    },
    serverListChange: function serverListChange(e) {
      console.log("eeee", e);
    },
    getList: function getList(e) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var params;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this2.show_test === '')) {
                  _context2.next = 3;
                  break;
                }

                _this2.$message.error(_this2.$t('pleaseSelectShowTestServer'));

                return _context2.abrupt("return");

              case 3:
                _this2.paramsData.page = e;
                _this2.reqLoading = true;
                _this2.serverList = []; // this.paramsData.server_id = [];
                //服务器数据处理

                if (_this2.paramsData.server_id && _this2.paramsData.server_id.length != 0) {
                  _this2.paramsData.servers = _this2.paramsData.server_id.map(function (item) {
                    _this2.serverList.push(item.split("+")[0]);

                    return {
                      openTimeTimestamp: item.split("+")[1],
                      id: item.split("+")[0]
                    };
                  });
                } else {
                  _this2.paramsData.servers = [];
                  _this2.serverList = [];
                  _this2.paramsData.open_server_day = [];
                }

                params = JSON.parse(JSON.stringify(_this2.paramsData));
                params.open_server_day = params.open_server_day && params.open_server_day.join(",");

                if (_this2.open_server_days) {
                  params.open_server_day = _this2.open_server_days;
                }

                if (_this2.serverList.length) {
                  params.server_id = _this2.serverList.join(",");
                }

                if (_this2.searchData.special_product_id.length) {
                  params.special_product_id = _this2.searchData.special_product_id.join(",");
                }

                params.server_channel = _this2.server_channel;
                params.show_test = _this2.show_test;
                delete params.server_ids;
                yjDailyPlayerDetails(_objectSpread(_objectSpread({}, params), {}, {
                  game_id: _this2.rawData.game_id
                })).then(function (res) {
                  if (res.status == 200) {
                    _this2.tableData = res.data || [];
                    _this2.total = res.total - 0 || 0; // this.currentPage = 1;
                    // this.tableCopyTableList = JSON.parse(JSON.stringify(res.data))
                    // this.tableData = this.currentChangePage(this.pageSize, this.currentPage)
                  }
                }).finally(function () {
                  _this2.reqLoading = false;
                });

              case 16:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    goToHistory: function goToHistory(row) {
      var params = {
        server_day: row.server_day,
        role_id: row.role_id,
        server_id: row.server_id,
        game_id: this.rawData.game_id,
        env_id: this.paramsData.env_id,
        server_channel: this.server_channel,
        show_test: this.show_test
      };
      this.$refs.historyList.init(params);
    },
    exportdata: function exportdata() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.exportdataDealoading = true; // let list = this.tableCopyTableList;

                if (!(_this3.show_test === '')) {
                  _context3.next = 4;
                  break;
                }

                _this3.$message.error(_this3.$t('pleaseSelectShowTestServer'));

                return _context3.abrupt("return");

              case 4:
                _this3.serverList = []; //服务器数据处理

                if (_this3.paramsData.server_id && _this3.paramsData.server_id.length != 0) {
                  _this3.paramsData.servers = _this3.paramsData.server_id.map(function (item) {
                    _this3.serverList.push(item.split("+")[0]);

                    return {
                      openTimeTimestamp: item.split("+")[1],
                      id: item.split("+")[0]
                    };
                  });
                } else {
                  _this3.paramsData.servers = [];
                  _this3.serverList = [];
                  _this3.paramsData.open_server_day = [];
                }

                params = JSON.parse(JSON.stringify(_this3.paramsData));
                params.open_server_day = params.open_server_day && params.open_server_day.join(",");

                if (_this3.serverList.length) {
                  params.server_id = _this3.serverList.join(",");
                }

                if (_this3.searchData.special_product_id.length) {
                  params.special_product_id = _this3.searchData.special_product_id.join(",");
                }

                params.server_channel = _this3.server_channel;
                params.show_test = _this3.show_test;
                delete params.server_ids;
                yjDailyPlayerDetails(_objectSpread(_objectSpread({}, params), {}, {
                  game_id: _this3.rawData.game_id,
                  page_size: -1
                })).then(function (res) {
                  if (res.status == 200) {
                    var list = res.data;
                    var columns = [{
                      label: _this3.$t('server'),
                      prop: 'server_id'
                    }, {
                      label: _this3.$t('openServerDay'),
                      prop: 'server_day'
                    }, {
                      label: _this3.$t('roleId'),
                      prop: 'role_id'
                    }, {
                      label: _this3.$t('roleName'),
                      prop: 'role_name'
                    }, {
                      label: _this3.$t('dailyPlayDuration'),
                      prop: 'duration'
                    }, {
                      label: _this3.$t('roleLevel'),
                      prop: 'level'
                    }, {
                      label: _this3.$t('roleFightPower'),
                      prop: 'fighting'
                    }, {
                      label: _this3.$t('mainLevel'),
                      prop: 'daily_task'
                    }, {
                      label: _this3.$t('totalRecharge'),
                      prop: 'total_amount'
                    }, {
                      label: _this3.$t('eventTime'),
                      prop: 'event_time'
                    }, {
                      label: _this3.$t('taskProgress'),
                      prop: 'main_line_task'
                    }, {
                      label: _this3.$t('registerTime'),
                      prop: 'register_time'
                    }, {
                      label: _this3.$t('lastLoginTime'),
                      prop: 'last_login_time'
                    }, {
                      label: _this3.$t('lastRechargeTime'),
                      prop: 'recharge_time'
                    }];

                    _this3.$export.excel({
                      columns: columns,
                      data: list,
                      title: _this3.$route.meta.title
                    });
                  }
                }).finally(function () {
                  _this3.exportdataDealoading = false;
                });

              case 14:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    }
  }
};